/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserNew
 */
export interface UserNew {
    /**
     * 
     * @type {string}
     * @memberof UserNew
     */
    email: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserNew
     */
    roles: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UserNew
     */
    partnerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserNew
     */
    signature: string;
}

/**
 * Check if a given object implements the UserNew interface.
 */
export function instanceOfUserNew(value: object): value is UserNew {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('partnerId' in value) || value['partnerId'] === undefined) return false;
    if (!('signature' in value) || value['signature'] === undefined) return false;
    return true;
}

export function UserNewFromJSON(json: any): UserNew {
    return UserNewFromJSONTyped(json, false);
}

export function UserNewFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserNew {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'roles': json['roles'],
        'partnerId': json['partnerId'],
        'signature': json['signature'],
    };
}

export function UserNewToJSON(json: any): UserNew {
    return UserNewToJSONTyped(json, false);
}

export function UserNewToJSONTyped(value?: UserNew | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'roles': value['roles'],
        'partnerId': value['partnerId'],
        'signature': value['signature'],
    };
}

